import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Clock, Droplets, Instagram, Facebook } from "lucide-react";
import { COMPANY, SERVICES, BAIRROS, bairroUrl, serviceUrl, waLink } from "@/data/site";

export const Footer = () => {
  return (
    <footer className="bg-brand-black text-gray-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto container-px py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-2 mb-4">
            <span className="grid place-items-center w-9 h-9 rounded-md bg-brand-red text-white">
              <Droplets className="w-5 h-5" />
            </span>
            <span className="font-display font-extrabold text-lg text-white">Paulistana</span>
          </Link>
          <p className="text-sm leading-relaxed text-gray-400">
            Desentupidora 24 horas especializada nos bairros nobres de São Paulo. Rapidez, higiene e garantia em cada atendimento.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="#" aria-label="Instagram" className="w-9 h-9 grid place-items-center rounded-md bg-brand-gray hover:bg-brand-red transition-colors">
              <Instagram className="w-4 h-4 text-white" />
            </a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 grid place-items-center rounded-md bg-brand-gray hover:bg-brand-red transition-colors">
              <Facebook className="w-4 h-4 text-white" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Serviços</h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={serviceUrl(s.slug)} className="hover:text-brand-red transition-colors" data-testid={`footer-service-${s.slug}`}>
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Atendimento</h4>
          <ul className="space-y-2 text-sm columns-1">
            {BAIRROS.slice(0, 10).map((b) => (
              <li key={b.slug}>
                <Link to={bairroUrl(b.slug)} className="hover:text-brand-red transition-colors">
                  {b.name}
                </Link>
              </li>
            ))}
            <li><Link to="/bairros.html" className="text-brand-red font-semibold hover:underline">Ver todos os bairros →</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Contato</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={`tel:${COMPANY.phoneTel}`} className="flex items-center gap-2 hover:text-brand-red transition-colors">
                <Phone className="w-4 h-4 text-brand-red" /> {COMPANY.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-wa-green transition-colors">
                <MessageCircle className="w-4 h-4 text-wa-green" /> Chamar no WhatsApp
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-brand-red mt-0.5 shrink-0" />
              <span>{COMPANY.address}, CEP {COMPANY.cep}</span>
            </li>
            <li className="flex items-start gap-2">
              <Clock className="w-4 h-4 text-brand-red mt-0.5 shrink-0" />
              <span>{COMPANY.hours}</span>
            </li>
          </ul>
          <div className="flex gap-2 mt-4">
            {["VISA", "MASTER", "PIX", "ELO"].map((c) => (
              <span key={c} className="text-[10px] font-bold bg-white text-brand-black rounded px-2 py-1">{c}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto container-px py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} {COMPANY.name} — CNPJ {COMPANY.cnpj}. Todos os direitos reservados.</p>
          <div className="flex gap-4">
            <Link to="/contato.html" className="hover:text-white">Contato</Link>
            <Link to="/sobre.html" className="hover:text-white">Sobre</Link>
            <span>Política de Privacidade</span>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto flex gap-3 px-4 pb-5 font-display" data-testid="footer-mobile-actions">
        <a
          href={`tel:${COMPANY.phoneTel}`}
          className="flex-1 rounded-2xl border border-brand-red/50 bg-gradient-to-r from-brand-red to-red-700 py-2 text-white shadow-lg shadow-brand-red/30 transition-transform active:scale-95"
          aria-label="Ligar agora"
        >
          <span className="flex items-center justify-center gap-2 text-lg font-bold uppercase tracking-wide">
            <Phone className="w-5 h-5" /> Ligar Agora
          </span>
          <span className="block -mt-1 text-center font-sans text-[11px] text-white/90">Atendimento 24h</span>
        </a>

        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 rounded-2xl border border-wa-green/50 bg-gradient-to-r from-wa-green to-wa-greenDark py-2 text-white shadow-lg shadow-wa-green/30 transition-transform active:scale-95"
          aria-label="Falar no WhatsApp"
        >
          <span className="flex items-center justify-center gap-2 text-lg font-bold uppercase tracking-wide">
            <MessageCircle className="w-6 h-6" fill="white" /> Chamar no WhatsApp
          </span>
          <span className="block -mt-1 text-center font-sans text-[11px] text-white/90">Orçamento Rápido</span>
        </a>
      </div>
    </footer>
  );
};
